export const getModalHeaderText = (
  i18n: Record<string, string>,
  isEditing: boolean
) => (isEditing ? i18n.EventFormCtrl_EditEvent : i18n.EventFormCtrl_AddEvent);
